<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible"
  >
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      @keyup.enter.native="dataFormSubmit()"
      label-width="120px"
    >
      <el-form-item label="企业名称" prop="enterpriseName">
        <el-input
          v-model="dataForm.enterpriseName"
          placeholder="企业名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="企业注册码" prop="businessLicenseNumber">
        <el-input
          v-model="dataForm.businessLicenseNumber"
          placeholder="工商注册码"
        ></el-input>
      </el-form-item>
      <el-form-item label="社会信用码" prop="enterpriseCode">
        <el-input
          v-model="dataForm.enterpriseCode"
          placeholder="请输入社会信用码"
        ></el-input>
      </el-form-item>
      <el-form-item label="所属行业" prop="industry">
        <el-select v-model="dataForm.industry" placeholder="请选择所属行业">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="公司规模" prop="scale">
        <el-select v-model="dataForm.scale" placeholder="请选择公司规模">
          <el-option
            v-for="item in options1"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="企业网站" prop="website">
        <el-input
          v-model="dataForm.website"
          placeholder="请输入企业网站"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="所属行业" prop="industry">
        <el-select v-model="dataForm.industry" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
            <span style="float: left">{{ item.name }}</span>
          </el-option>
        </el-select>
      </el-form-item> -->
      <!-- <el-form-item label="所属区域" prop="areaCode">
        <el-select v-model="dataForm.areaCode" placeholder="请选择">
          <el-option
            v-for="item in areaList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
            <span style="float: left">{{ item.name }}</span>
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="企业类型" prop="enterpriseType">
        <el-radio-group v-model="dataForm.enterpriseType">
          <el-radio :label="0">国企</el-radio>
          <el-radio :label="1">民企</el-radio>
          <el-radio :label="2">私企</el-radio>
          <el-radio :label="3">外企</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="企业联系电话" prop="telephone">
        <el-input
          v-model="dataForm.telephone"
          placeholder="企业联系电话"
        ></el-input>
      </el-form-item>
      <el-form-item label="企业邮箱" prop="email">
        <el-input v-model="dataForm.email" placeholder="企业邮箱"></el-input>
      </el-form-item>
      <el-form-item label="邮政编码" prop="zipCode">
        <el-input v-model="dataForm.zipCode" placeholder="邮政编码"></el-input>
      </el-form-item>
      <el-form-item label="城市编码" prop="cityCode">
        <el-input v-model="dataForm.cityCode" placeholder="城市编码"></el-input>
      </el-form-item>
      <el-form-item label="法人" prop="legalPerson">
        <el-input v-model="dataForm.legalPerson" placeholder="法人"></el-input>
      </el-form-item>
      <el-form-item label="管理员姓名" prop="mainPerson">
        <el-input
          v-model="dataForm.mainPerson"
          placeholder="企业管理员姓名"
        ></el-input>
      </el-form-item>
      <el-form-item label="管理员电话" prop="mainPersonMobile">
        <el-input
          v-model="dataForm.mainPersonMobile"
          placeholder="企业管理人电话"
        ></el-input>
      </el-form-item>
      <el-form-item label="企业介绍" prop="introduction">
        <el-button
          type="info"
          icon="el-icon-edit"
          size="small"
          @click="openRichDialog"
          >前往编写企业介绍</el-button
        >
      </el-form-item>
      <!-- <el-form-item label="企业描述" class="describe-enterprise">
                    <el-input
                        type="textarea"
                        :rows="3"
                        placeholder="请输入内容"
                        v-model="enterprise.description"
                    >
                    </el-input>
                </el-form-item> -->
      <!-- <el-form-item label="x坐标" prop="mapX">
        <el-input v-model="dataForm.mapX" placeholder="x坐标"></el-input>
      </el-form-item>
      <el-form-item label="y坐标" prop="mapY">
        <el-input v-model="dataForm.mapY" placeholder="y坐标"></el-input>
      </el-form-item>
      <el-form-item label="z坐标" prop="mapZ">
        <el-input v-model="dataForm.mapZ" placeholder="z坐标"></el-input>
      </el-form-item> -->
      <el-form-item label="logo图片" prop="logo">
        <el-upload
          class="upload"
          ref="upload"
          :action="uploadUrl"
          name="file"
          :limit="1"
          accept=".png,.jpg"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-upload="beforeUpload"
          :on-success="handleSuccess"
          :file-list="fileList"
          list-type="picture"
        >
          <el-button slot="trigger" size="small" type="primary"
            >选取文件</el-button
          >

          <div slot="tip" class="el-upload__tip">
            只能上传 .png .jpg图片，且不超过10MB
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item label="承诺书" prop="commitment">
        <el-upload
          class="upload"
          ref="upload"
          :action="uploadUrl"
          name="file"
          :limit="1"
          accept=".png,.jpg"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-upload="beforeUpload"
          :on-success="handleSuccess2"
          :file-list="fileList3"
          list-type="picture"
        >
          <el-button slot="trigger" size="small" type="primary"
            >选取文件</el-button
          >

          <div slot="tip" class="el-upload__tip">
            只能上传 .png .jpg图片，且不超过10MB
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item label="营业执照" prop="businessLicense">
        <el-upload
          class="upload"
          ref="upload"
          :action="uploadUrl"
          name="file"
          :limit="1"
          accept=".png,.jpg"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-upload="beforeUpload"
          :on-success="handleSuccess1"
          :file-list="fileList2"
          list-type="picture"
        >
          <el-button slot="trigger" size="small" type="primary"
            >选取文件</el-button
          >

          <div slot="tip" class="el-upload__tip">
            只能上传 .png .jpg图片，且不超过10MB
          </div>
        </el-upload>
      </el-form-item>
      <!-- //添加附件 -->
      <el-form-item label="法人模板">
        <video-upload
          ref="videoUploaded"
          @videoUploaded="videoUploaded"
          @removeVideo="removeVideo"
          :videoList="preVideo"
        />
      </el-form-item>
      <el-form-item label="模板外链">
        <el-input
          v-model="dataForm.corporate"
          placeholder="请输入文件外链"
          @input="isHaveVideo"
        ></el-input>
      </el-form-item>
      <el-form-item label="地址" prop="address">
        <el-input v-model="dataForm.address" placeholder="地址"></el-input>
      </el-form-item>
      <el-form-item label="企业状态" prop="status">
        <el-radio-group v-model="dataForm.status">
          <el-radio :label="0">正常</el-radio>
          <el-radio :label="1">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- <el-form-item label="企业附件" prop="">
        <el-upload
          class="upload-demo"
          ref="upload"
          :action="uploadUrl"
          name="file"
          accept=".doc,.docx,.xls,.xlsx,.pdf,.png,.jpg,.gif"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-upload="beforeUpload"
          :on-success="handleSuccess"
          :file-list="fileList"
          :auto-upload="false"
        >
          <el-button slot="trigger" size="small" type="primary"
            >选取文件</el-button
          >
          <el-button
            style="margin-left: 10px"
            size="small"
            type="success"
            @click="submitUpload"
            >上传到服务器</el-button
          >
          <div slot="tip" class="el-upload__tip">
            只能上传doc/docx/xls/xlsx/pdf/png/jpg/gif文件，且不超过100MB
          </div>
        </el-upload>
      </el-form-item> -->
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
    <!-- 企业介绍对话框 -->
    <el-dialog
      width="50%"
      title="企业介绍"
      :visible.sync="innerVisible"
      append-to-body
      @closed="destroyEdit"
    >
      <div id="demo1"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="innerVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
// 引入过滤函数
import { showcontent } from "@/utils/method.js";
import VideoUpload from "@/views/modules/config/child-components/upload-test";
// 引入 wangEditor
import wangEditor from "wangeditor";
export default {
  components: {
    // Editor
    VideoUpload,
  },
  data() {
    return {
      value1: '',
      value:'',
      editor: null,
      innerVisible: false,
      visible: false,
      options1: [{
        value: '0-50人',
        label: '0-50人'
      }, {
        value: '50-100人',
        label: '50-100人'
      },{
        value: '100-500人',
        label: '100-500人'
      },{
        value: '500-1000人',
        label: '500-1000人'
      },{
        value: '1000人以上',
        label: '1000人以上'
      }],
      options: [{
        value:'农、林、牧、渔业',
        label:'农、林、牧、渔业',
      },
      {
        value:'采矿业',
        label:'采矿业',
      },
      {
        value:'电力、热力、燃气及水的生产和供应业',
        label:'电力、热力、燃气及水的生产和供应业',
      },
      {
        value:'环境和公共设施管理业',
        label:'环境和公共设施管理业',
      },
      {
        value:'建筑业',
        label:'建筑业',
      },
      {
        value:'交通运输、仓储业和邮政业',
        label:'交通运输、仓储业和邮政业',
      },
      {
        value:'信息传输、计算机服务和软件业',
        label:'信息传输、计算机服务和软件业',
      },
      {
        value:'批发和零售业',
        label:'批发和零售业',
      },
      {
        value:'住宿、餐饮业',
        label:'住宿、餐饮业',
      },
      {
        value:'金融、保险业',
        label:'金融、保险业',
      },
      {
        value:'房地产业',
        label:'房地产业',
      },
      {
        value:'科学研究、技术服务和地质勘查业',
        label:'科学研究、技术服务和地质勘查业',
      },
      {
        value:'水利、环境和公共设施管理业',
        label:'水利、环境和公共设施管理业',
      },
      {
        value:'教育',
        label:'教育',
      },
      {
        value:'文化、体育、娱乐业',
        label:'文化、体育、娱乐业',
      },
      {
        value:'卫生、社会保障和社会服务业',
        label:'卫生、社会保障和社会服务业',
      }],
      dataForm: {
        id: 0,
        scale:'',
        businessLicenseNumber: "",
        enterpriseCode: "",
        enterpriseName: "",
        industry: "",
        areaCode: "",
        enterpriseType: 0,
        telephone: "",
        email: "",
        zipCode: "",
        cityCode: "",
        legalPerson: "",
        mainPerson: "",
        mainPersonMobile: "",
        mapX: "",
        mapY: "",
        mapZ: "",
        introduction: "",
        address: "",
        status: 0,
        logo: "",
        website: "",
        commitment:'',
        businessLicense:''
      },
      industryList: [],
      areaList: [],
      uploadUrl: "",
      fileList: [],
      fileList2: [],
      fileList3: [],
      preVideo: [],
      dataRule: {
        businessLicenseNumber: [
          {
            required: false,
            message: "企业注册码(工商注册码-三证合一)不能为空",
            trigger: "blur",
          },
        ],
        scale:[
        { required: true, message: "企业规模", trigger: "blur" },
        ],
        enterpriseCode: [
          { required: true, message: "社会信用码不能为空", trigger: "blur" },
        ],
        enterpriseName: [
          { required: true, message: "企业名称不能为空", trigger: "blur" },
        ],
        industry: [
          { required: true, message: "所属行业不能为空", trigger: "blur" },
        ],
        areaCode: [
          { required: true, message: "所属区域不能为空", trigger: "blur" },
        ],
        enterpriseType: [
          { required: false, message: "企业类型不能为空", trigger: "blur" },
        ],
        telephone: [
          { required: true, message: "企业联系电话不能为空", trigger: "blur" },
          { pattern:/^1(2|3|4|5|6|7|8|9)\d{9}$/, message: "你的手机号格式不正确" },
        ],
        email: [
          { required: true, message: "企业邮箱不能为空", trigger: "blur" },
          {
            pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: "你的邮箱格式不正确",
            trigger: "blur",
          },
        ],
        zipCode: [
          { required: false, message: "邮政编码不能为空", trigger: "blur" },
        ],
        commitment:[
          { required: true, message: "承诺书不能为空", trigger: "blur" },
        ],
        businessLicense:[
          { required: true, message: "营业执照不能为空", trigger: "blur" },
        ],
        // cityCode: [
        //   { required: true, message: "城市编码不能为空", trigger: "blur" },
        // ],
        // legalPerson: [
        //   { required: true, message: "法人不能为空", trigger: "blur" },
        // ],
        mainPerson: [
          {
            required: true,
            message: "企业负责人姓名不能为空",
            trigger: "blur",
          },
        ],
        introduction: [
          {
            required: false,
            message: "请输入企业简介",
            trigger: "blur",
          },
        ],
        mainPersonMobile: [
          {
            required: true,
            message: "企业负责人移动电话号码不能为空",
            trigger: "blur",
          },
          { pattern:/^1(2|3|4|5|6|7|8|9)\d{9}$/, message: "你的手机号格式不正确" },
        ],
        mapX: [{ required: true, message: "x坐标不能为空", trigger: "blur" }],
        logo: [
          { required: true, message: "logoa图片不能为空", trigger: "blur" },
        ],
        mapY: [{ required: true, message: "y坐标不能为空", trigger: "blur" }],
        mapZ: [{ required: true, message: "z坐标不能为空", trigger: "blur" }],
        address: [{ required: false, message: "地址不能为空", trigger: "blur" }],
        status: [
          { required: true, message: "企业状态不能为空", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    init(id) {
      this.dataForm.id = id || 0;
      this.visible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
        this.uploadUrl = 'https://activity.suhoo.net/api/upload/image';
        this.fileList = [];
        this.fileList2 = [];
        this.fileList3 = [];
        // this.lookFile(id);
        this.initIndustryList();
        this.initAreaList();
        if (this.dataForm.id) {
          this.$http({
            url: this.$http.adornUrl(
              `/enterprise/info/open/${this.dataForm.id}`
            ),
            method: "get",
            params: this.$http.adornParams(),
          }).then(({ data }) => {
            console.log("企业信息", data);
            if (data && data.code === 0) {
              this.dataForm.businessLicenseNumber =
                data.data.businessLicenseNumber;
              this.dataForm.scale = data.data.scale
              this.dataForm.enterpriseCode = data.data.enterpriseCode;
              this.dataForm.enterpriseName = data.data.enterpriseName;
              this.dataForm.industry = data.data.industry;
              this.dataForm.areaCode = data.data.areaCode;
              this.dataForm.enterpriseType = data.data.enterpriseType;
              this.dataForm.telephone = data.data.telephone;
              this.dataForm.email = data.data.email;
              this.dataForm.zipCode = data.data.zipCode;
              this.dataForm.cityCode = data.data.cityCode;
              this.dataForm.legalPerson = data.data.legalPerson;
              this.dataForm.mainPerson = data.data.mainPerson;
              this.dataForm.mainPersonMobile = data.data.mainPersonMobile;
              this.dataForm.introduction = data.data.introduction;
              this.dataForm.address = data.data.address;
              this.dataForm.status = data.data.status;
              this.dataForm.logo = data.data.logo;
              this.dataForm.businessLicense = data.data.businessLicense;
              this.dataForm.commitment = data.data.commitment;
              this.dataForm.website = data.data.website;
              this.dataForm.corporate = data.data.corporate;
              // 将图片展示
              console.log(this.dataForm.logo);
              if (this.dataForm.logo) {
                const obj = {
                  url: this.dataForm.logo,
                };
                this.fileList = [obj];
              }
              if (this.dataForm.businessLicense) {
                const obj = {
                  url: this.dataForm.businessLicense,
                };
                this.fileList2 = [obj];
              }
              if (this.dataForm.commitment) {
                const obj = {
                  url: this.dataForm.commitment,
                };
                this.fileList3 = [obj];
              }
                if (this.dataForm.corporate) {
                this.preVideo = [
                { url: this.dataForm.corporate },
              ];
              }
              // let  obj = {
              //                   url: this.dataForm.logo,
              //               };
              //               this.fileList = [obj];
            }
          });
        }
      });
    },

    //  init(id) {
    //         this.news.id = id || 0;
    //         this.visible = true;
    //         this.getCategories();
    //         this.$nextTick(() => {
    //             this.$refs["news"].resetFields();
    //             this.uploadUrl = this.$http.adornUrl(
    //                 `/image/upload/open?token=` + this.$cookie.get("token")
    //             );
    //             if (this.news.id) {
    //                 this.$http({
    //                     url: this.$http.adornUrl(`/news/open/${this.news.id}`),
    //                     method: "get",
    //                     params: this.$http.adornParams(),
    //                 }).then(({ data }) => {
    //                     if (data && data.code === 0) {
    //                         this.news = JSON.parse(
    //                             showcontent(JSON.stringify(data.data))
    //                         );
    //                         if (this.news.thumb) {
    //                             const obj = {
    //                                 url: this.news.thumb,
    //                             };
    //                             this.fileList = [obj];
    //                         }
    //                     }
    //                 });
    //             }
    //         });
    //     },
    //关闭企业介绍后销毁编辑器
    destroyEdit() {
      if (this.editor) {
        this.editor.destroy();
        this.editor = null;
      }
    },
     // 视频上传完成
    videoUploaded(url) {
      // debugger
      console.log(this.dataForm.corporate);
      if (this.dataForm.corporate != undefined && this.dataForm.corporate != "") {
        this.$refs.videoUploaded.clearFiles();
        this.$message({
          title: "错误",
          type: "error",
          message: "视频外链已上传，请删除后选择文件上传",
        });
      } else {
        this.dataForm.corporate = url;
      }
    },
     isHaveVideo() {
      // console.log(this.news.enclosure);
      if (this.dataForm.corporate != "") {
        // this.$message({
        //   title: "错误",
        //   type: "error",
        //   message: "视频外链已上传，请删除后选择文件上传",
        // });
      }
    },
    // 移除上传的视频
    removeVideo() {
      this.dataForm.corporate = "";
    },
    // 点击编写企业介绍按钮
    openRichDialog() {
      this.innerVisible = true;
      if (!this.editor) {
        this.$nextTick(() => {
          // 创建富文本编辑器实例
          const editor = new wangEditor("#demo1");
          // 配置 onchange 回调函数，将数据同步到 vue 中
          editor.config.onchange = (newHtml) => {
            this.dataForm.introduction = newHtml;
          };
          editor.config.uploadImgServer = this.uploadUrl;
          editor.config.showLinkImg = false;
          editor.config.uploadFileName = "file";
          editor.config.customUploadImg = function (resultFiles, insertImgFn) {
            let objectURL = URL.createObjectURL(resultFiles[0]);
            insertImgFn(objectURL);
          };
          // 创建编辑器
          editor.create();
          if (this.dataForm.introduction !== "") {
            editor.txt.html(
              showcontent(showcontent(this.dataForm.introduction))
            );
            // editor.txt.html(this.activities.context);
          }
          this.editor = editor;
        });
      }
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate((valid) => {
        // console.log(this.dataForm)
        if (valid) {
          // debugger
          this.$http({
            url: this.$http.adornUrl(
              `/enterprise/${!this.dataForm.id ? "save" : "update"}`
            ),
            method: "post",
            data: this.$http.adornData({
              id: this.dataForm.id || undefined,
              businessLicenseNumber: this.dataForm.businessLicenseNumber,
              enterpriseCode: this.dataForm.enterpriseCode,
              enterpriseName: this.dataForm.enterpriseName,
              industry: this.dataForm.industry,
              scale:this.dataForm.scale,
              areaCode: this.dataForm.areaCode,
              enterpriseType: this.dataForm.enterpriseType,
              telephone: this.dataForm.telephone,
              email: this.dataForm.email,
              zipCode: this.dataForm.zipCode,
              cityCode: this.dataForm.cityCode,
              legalPerson: this.dataForm.legalPerson,
              mainPerson: this.dataForm.mainPerson,
              mainPersonMobile: this.dataForm.mainPersonMobile,
              introduction: this.dataForm.introduction,
              // mapX: this.dataForm.mapX,
              // mapY: this.dataForm.mapY,
              // mapZ: this.dataForm.mapZ,
              address: this.dataForm.address,
              status: this.dataForm.status,
              logo: this.dataForm.logo,
              website: this.dataForm.website,
              commitment: this.dataForm.commitment,
              businessLicense: this.dataForm.businessLicense,
              corporate:this.dataForm.corporate
            }),
          }).then(({ data }) => {
            if (data && data.code === 0) {
              this.$message({
                message: "操作成功",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                },
              });
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      });
    },
    initIndustryList() {
      this.industryList = [];
      this.$http({
        url: this.$http.adornUrl("/sys/dic/select/9"),
        method: "get",
        params: this.$http.adornParams(),
      }).then(({ data }) => {
        this.industryList = data.data;
      });
    },
    initAreaList() {
      this.areaList = [];
      this.$http({
        url: this.$http.adornUrl("/sys/dic/select/16"),
        method: "get",
        params: this.$http.adornParams(),
      }).then(({ data }) => {
        this.areaList = data.data;
      });
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList);
      this.deleteFile(file);
    },
    handlePreview(file) {
      // console.log(file);
      window.open(file.url, "_blank").location;
    },
    beforeUpload(file) {
      const isLt100M = file.size / 1024 / 1024 < 100;
      if (!isLt100M) {
        this.$message.error("上传文件大小不能超过 100MB!");
      }
      return isLt100M;
    },
    // 关闭对话框触发事件
    courseDialogClose() {
      this.$refs["dataForm"].resetFields();
      this.preVideo = [];
    },
    handleSuccess(response, file, fileList) {
                console.log(response);
      // console.log(response);
      if (response && response.code === 0) {
        file.name = response.data.name;
        this.dataForm.logo = response.data;
        // this.dataForm.website = response.data;
      }
      // console.log(file);
      // console.log(fileList);
    },
    handleSuccess1(response, file, fileList) {
      // console.log(response);
      if (response && response.code === 0) {
        file.name = response.data.name;
	    let url = (response.data.fileInfo.domain ? response.data.fileInfo.domain+'/' : 'https://activity.suhoo.net/')+response.data.fileInfo.file_path;
        this.dataForm.businessLicense = url;
      }
      // console.log(file);
      // console.log(fileList);
    },
    handleSuccess2(response, file, fileList) {
      // console.log(response);
      if (response && response.code === 0) {
        file.name = response.data.name;
	    let url = (response.data.fileInfo.domain ? response.data.fileInfo.domain+'/' : 'https://activity.suhoo.net/')+response.data.fileInfo.file_path;
        this.dataForm.commitment = url;
      }
      // console.log(file);
      // console.log(fileList);
    },
    // 删除文件
    deleteFile(file) {
      this.$http({
        url: this.$http.adornUrl("/enterprise/deleteFile"),
        method: "get",
        params: this.$http.adornParams({
          id: this.dataForm.id,
          name: file.name,
          url: file.url,
        }),
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.$message({
            message: data.msg,
            type: "success",
          });
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    // 查看文件
    // lookFile(id) {
    //   this.$http({
    //     url: this.$http.adornUrl("/enterprise/lookFile/" + id),
    //     method: "get",
    //     params: this.$http.adornParams(),
    //   }).then(({ data }) => {
    //     if (data && data.code === 0) {
    //       this.fileList = data.data;
    //     }
    //   });
    // },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-input.el-input--suffix{
  // width: 330%;
}
</style>
